exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table thead th[data-v-71dd0d6b]:first-child{width:100px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/menu-attribute/List.vue"],"names":[],"mappings":"AACA,6CACE,WAAa,CACd","file":"List.vue","sourcesContent":["\n.table thead th[data-v-71dd0d6b]:nth-child(1){\n  width: 100px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71dd0d6b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/menu-attribute/List.vue
// module id = 2338
// module chunks = 0